import { defineMessages, useIntl } from 'react-intl';

import AuthModal from '@/components/authForm/AuthModal';
import Footer from '@/components/footer/FooterWrapper';
import Header from '@/components/header/Header';
import Layout from '@/components/layout/LayoutWrapper';
import Features from '@/components/plans/Features';
import Hero from '@/components/plans/Hero';
import PlanSubtext from '@/components/plans/PlanSubtext';
import AuthModalContextProvider from '@/context/AuthModalContextProvider';
import { InitRequest, useInitState } from '@/hooks/store';
import { User } from '@/store/user/types';
import redirect from '@/utils/legacy/redirect';
import { userCanTrial } from '@/utils/subscriptions';

const messages = defineMessages({
	title: {
		id: 'plans.pageTitle',
		defaultMessage: 'Calm - Subscription Plans',
		description: 'Page title for planspage',
	},
});

const Plans = () => {
	const { formatMessage } = useIntl();

	useInitState({
		requests: [InitRequest.PRICES, InitRequest.DEVICE, InitRequest.USER],
	});

	const onAuthSuccess = (user: User) => {
		const redirectUrl = userCanTrial(user) ? '/freetrial' : '/subscribe';
		redirect(redirectUrl);
	};

	return (
		<Layout pageName="free_trial_plans" title={formatMessage(messages.title)}>
			<Header hideMenu />
			<AuthModalContextProvider>
				<Hero />
				<PlanSubtext />
				<Features />
				<AuthModal onAuthSuccess={onAuthSuccess} />
			</AuthModalContextProvider>
			<Footer />
		</Layout>
	);
};

export default Plans;
